import { useNavigate, useParams } from "react-router-dom";
import { RoutedModal } from "../../../../components/common";
import { pathConstants } from "../../../../routes/pathContants";
import secondaryComponents from "../../../../components/secondaryComponents";
import useReturns from "../../../appPages/Inventory/Returns/useReturns";
import { useEffect } from "react";
import primaryComponents from "../../../../components/primaryComponents";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";

export const SMReturns = () => {
  const navigate = useNavigate();
  const { store_id } = useParams();

  const {
    isLoadingReturns,
    returns,
    metaDetails,
    isReturn,
    search,
    setIsReturn,
    gotoPage,
    filterByStoreId,
  } = useReturns();

  useEffect(() => {
    if (!search.get("store_id")) filterByStoreId(store_id);
  }, []);

  return (
    <RoutedModal
      isActive={true}
      headerTitle="Returns"
      headerDescription="Record products returned by your customers."
      closeModal={() =>
        navigate(pathConstants.SELL_MODE({ store_id: store_id }))
      }
    >
      <secondaryComponents.NavigateWithPermission
        permissionParentKey={"Inventory Management"}
        permissionChildKey="can_return_products"
      >
        <primaryComponents.Button
          classNames={"btn btn--primary ml-auto"}
          onClick={() => setIsReturn(true)}
        >
          + Return Product
        </primaryComponents.Button>
      </secondaryComponents.NavigateWithPermission>

      <secondaryComponents.LoaderHelper
        isLoading={isLoadingReturns}
        classNames="mt-5"
      >
        <div className={`${globalStyles.cardWithBorder} p-0`}>
          <secondaryComponents.ReturnsTable
            returns={returns}
            metaDetails={metaDetails}
            gotoPage={gotoPage}
          />
        </div>
      </secondaryComponents.LoaderHelper>

      <secondaryComponents.SideModal
        width={700}
        isActive={isReturn}
        closeModal={() => setIsReturn(false)}
      >
        <secondaryComponents.ReturnStockWidget
          closeWidget={() => setIsReturn(false)}
        />
      </secondaryComponents.SideModal>
    </RoutedModal>
  );
};
